import { Component, OnInit } from '@angular/core';
import { RequestComponent } from 'src/app/Helper/request/request.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(private sanitizer:DomSanitizer) { }
  info;
  ambiente = RequestComponent.returnEnv();
  url = RequestComponent.connectionUrl();
  urlfinal ;
  msgRetorno;
  ngOnInit() {
  }


  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}

